import { useTranslation } from '@packages/utils';
import { TColumnType } from 'components/Base/Table/Table.types';
import { CopyTextButton } from 'components/Base/CopyTextButton';
import { ESortDirection } from 'data/types/generic.types';
import {
  EWaitListColumnKey,
  TEventWaitListUI,
} from 'data/types/registrants.types';
import { ParagraphEllipsis } from 'components/Shared/ParagraphEllipsis';
import useGetTableColumnData from 'components/Base/Table/components/SearchFilter';

export const ANSWER_MAX_LENGTH = 44;

const useGetData = () => {
  const { t } = useTranslation();
  const { getTableColumnSearchProps } = useGetTableColumnData();
  const defaultSortParam = {
    sortField: EWaitListColumnKey.CREATION_DATE,
    sortDirection: ESortDirection.descend,
  };

  const defaultColumns: TColumnType<TEventWaitListUI>[] = [
    {
      title: t(
        'descriptions.admin-portal.events.details.event-wait-list.table.title.REGISTRATION_DATE',
      ),
      dataIndex: 'createdDate',
      key: EWaitListColumnKey.CREATION_DATE,
      sorter: true,
    },
    {
      title: t(
        'descriptions.admin-portal.events.details.event-wait-list.table.title.FIRST_NAME',
      ),
      dataIndex: 'firstName',
      key: EWaitListColumnKey.FIRST_NAME,
      sorter: true,
      ...getTableColumnSearchProps<TEventWaitListUI>(),
    },
    {
      title: t(
        'descriptions.admin-portal.events.details.event-wait-list.table.title.LAST_NAME',
      ),
      dataIndex: 'lastName',
      key: EWaitListColumnKey.LAST_NAME,
      sorter: true,
      ...getTableColumnSearchProps<TEventWaitListUI>(),
    },
    {
      title: t(
        'descriptions.admin-portal.events.details.event-wait-list.table.title.MOBILE',
      ),
      dataIndex: 'phone',
      key: 'phone',
      ellipsis: true,
    },
    {
      title: t(
        'descriptions.admin-portal.events.details.event-wait-list.table.title.EMAIL',
      ),
      dataIndex: 'email',
      key: 'email',
      ...getTableColumnSearchProps<TEventWaitListUI>(),
      onCell: () => ({
        className: 'custom-cell',
        style: { maxWidth: '130px' },
        onClick: e => {
          e.stopPropagation();
        },
      }),
      render: (text, record) => {
        return <CopyTextButton title={record.email} />;
      },
    },
    {
      title: t(
        'descriptions.admin-portal.events.details.event-wait-list.table.title.QUESTION_ANSWER',
      ),
      dataIndex: 'customQuestionAnswer',
      key: 'customQuestionAnswer',
      render: answer => {
        return (
          <ParagraphEllipsis text={answer} textMaxLength={ANSWER_MAX_LENGTH} />
        );
      },
      onCell: () => ({
        style: { minWidth: '180px' },
      }),
    },
    {
      title: ' ',
      dataIndex: 'actions',
      key: 'actions',
      fixed: 'right',
      width: 50,
      render: () => null,
    },
  ];

  return { defaultColumns, defaultSortParam };
};

export default useGetData;
